export default __webpack_public_path__ + "static/media/35t.6c977f5f.jpg";